<template>
  <span v-if="this.show" class="unavailable"> UNAVAILABLE</span>
</template>

<script>
export default {
  props: {
    parkingLot: {
      type: Object,
      default: null
    },
    desktop: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    show() {
      if (!this.desktop) {
        return true;
      }
      return this.parkingLot.service || (!this.parkingLot.service && !this.parkingLot.on_airport)
    }
  }
}
</script>